import { type CSSProperties, type ReactNode } from "react";

export function Reveal({
  children,
  delay = 0,
  className,
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  return (
    <div
      className={className ? `crew-reveal ${className}` : "crew-reveal"}
      style={delay ? ({ animationDelay: `${delay}s` } satisfies CSSProperties) : undefined}
    >
      {children}
    </div>
  );
}
